import { fetch as fetchPolyfill } from 'whatwg-fetch';

const STATICS = {
    ENDPOINT: 'https://d25imd56ol85jt.cloudfront.net',
    SYOS: null,
    PROXY: null,
    TNEW: null,
    // TNEW: 'https://my.writerstheatre.org', // Live
    // TNEW: 'https://writ-tnew-test.tnhs.cloud', // Test
    SEAT_CURVE_WEB_CONTENT_DESCRIPTION: 'seatcurve syos enabled',
    LIVE_TNEW_DOMAIN: 'https://my.writerstheatre.org',
};

export async function setupEndpoints() {
    const release = await getRelease();

    STATICS.SYOS = `${STATICS.ENDPOINT}/syos/releases/${release}`;
    STATICS.PROXY = `${STATICS.ENDPOINT}/proxy`;

    let tnewEndpoint = window.AppConfig.tnewDomain;

    if (tnewEndpoint.endsWith('/')) {
        tnewEndpoint = tnewEndpoint.slice(0, -1);
    }

    STATICS.TNEW = tnewEndpoint;
}

function isLiveTnew() {
    const parsedUrl = new URL(window.location.href);
    const origin = parsedUrl.origin;

    return origin === STATICS.LIVE_TNEW_DOMAIN;
}

async function getRelease() {
    if (!isLiveTnew()) {
        return 'develop';
    }

     return await fetchPolyfill(`${STATICS.ENDPOINT}/syos/release_tag.json`)
         .then(response => response.json())
         .then(response => response.tag);
}

const config = {
    currencyCode: 'USD',
    timezone: 'America/Chicago',
    // Format to display performance date and time - see https://date-fns.org/v1.28.5/docs/format
    dateTimeFormat: 'EEE, MMMM d, yyyy, h:mmaaa',
    features: {
        viewFromSeat: {
            enabled: true,
            endpoint: `${STATICS.ENDPOINT}/syos/seat-images/seat-images.json`,
        },
        performanceSelector: {
            enabled: false
        },
        seatColours: {
            enabled: false
        },
        levelSelector: {
            enabled: true,
            labelHelp: 'Select your preferred seating area'
        },
        promoCode: {
            enabled: true,
            defaultSourceNo: 2644,
        },
    },
    facilityMapping: [
        {
            facility_no: 20,
            title: 'The Nichols',
            customIconSize: 30,
            svg: `${STATICS.ENDPOINT}/syos/seat-maps/nichols/map.svg`
        }
    ],
    seatMessages: [
        {
            seatTypeIds: [8],
            holdCodeIds: [],
            text: 'You have selected an ADA seat that requires transferring from your wheelchair to the theatre seat. If you will be remaining in your wheelchair, please call us at 847-242-6000 or email boxoffice@writerstheatre.org before you complete your purchase and we will assist you with the appropriate seating adjustments.'
        },
        {
            seatTypeIds: [13],
            holdCodeIds: [],
            text: 'You have selected a seat allocated for the companion of a patron using a wheelchair.'
          },
          {
            seatTypeIds: [17],
            holdCodeIds: [],
            text: 'You have selected a seat located underneath the air vent. Please note that cold air may affect this seat.'
          },
    ],
    seatTypes: {
        customTypes: [
            {
                label: 'Wheelchair',
                id: 'WheelchairSeat',
                slug: 'accessible',
                method: 'custom',
                customName: 'custom-icon-wheelchair',
                seatTypeIds: [8],
            },
            {
                label: 'Companion',
                id: 'CompanionSeat',
                slug: 'companion',
                method: 'custom',
                customName: 'custom-icon-companion',
                seatTypeIds: [13],
            },
            {
                label: 'Vent',
                id: 'VentSeat',
                slug: 'vent',
                method: 'custom',
                customName: 'custom-icon-vent',
                seatTypeIds: [17],
            },
        ],
    },
    fallbacks: {
        // URL to use in case anything goes wrong with SYOS - it's suggested to use an alternative
        // to SYOS such as best available so customers can still book tickets
        fallbackUrl: `?z=0`,

        returnUrl: `https://writerstheatre.org/plays-and-events/calendar`,

        // Message to show in case of any issues with SYOS
        defaultMessage: 'There was an error loading select your own seat.',
        // Message to show to unsupported browsers - this is mostly historic thing as browsers
        // are now modern enough to run the SYOS application
        unsupportedMessage:
            'Your browser does not support select your own seat.'
    }
};

export { STATICS, config };
